import React from 'react';
import ModalWrapper from '../ModalWrapper';

import ModalConfigurationDetailBody from './ModalConfigurationDetailBody';

const ModalConfigurationDetail = ({ isOpen, onCloseModal }) => (
    <ModalWrapper isOpen={isOpen} cssClass="modal-financiado">
        <ModalConfigurationDetailBody onCloseModal={onCloseModal} />
    </ModalWrapper>
);

export default ModalConfigurationDetail;